<div class="container">
  @if(isLoading) {
  <div class="row">
    <div class="p-5 col-md-12 d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  } @else { @if(user) {
  <div class="row d-lg-flex flex-row">
    <div class="col-lg-8 pt-4">
      <mat-card class="mat-elevation-z0 border rounded text-left">
        <mat-card-content class="p-4">
          <div class="profileCardContainer">
            <img
              *ngIf="profilePicture"
              class="profile-pic"
              [src]="profilePicture"
              alt=""
            />
            <div
              class="profileInfoContainer d-flex flex-column justify-content-center flex-grow-1 w-100 text-center"
            >
              <div class="d-flex justify-content-between">
                <h1 class="mat-h1 mb-2 flex-full text-left">
                  {{ user.displayName }}
                </h1>
                <mat-chip-set class="d-flex pb-2 ml-3">
                  <mat-chip color="accent" *ngIf="isMyProfile">You</mat-chip>
                  <mat-chip *ngIf="!isMyProfile && false">Follows you</mat-chip>
                </mat-chip-set>
              </div>
              <div class="d-md-flex flex-row justify-content-between">
                <h3 *ngIf="false" class="mat-h3 text-left mb-2">
                  Member of <strong>Team name</strong>
                </h3>
                <h3 *ngIf="user.startTimeDiffString" class="mat-h3 mb-2">
                  Freerunner since {{ user.startTimeDiffString }}
                </h3>
              </div>
              <h3 class="mat-h3">
                <strong>
                  <app-fancy-counter
                    [number]="user.followerCount || 0"
                  ></app-fancy-counter
                ></strong>
                Follower{{ user.followerCount === 1 ? "" : "s" }}
              </h3>
              <div *ngIf="!isMyProfile" class="profileButtonRow d-flex">
                <button
                  mat-flat-button
                  [color]="isFollowing ? 'primary' : 'accent'"
                  class="d-flex justify-content-center align-items-center align-middle"
                  (click)="followButtonClick()"
                >
                  <mat-spinner
                    *ngIf="loadingFollowing"
                    diameter="24"
                    class="float-left followingSpinner mr-2"
                  ></mat-spinner>
                  {{ isFollowing ? "Unfollow" : "Follow" }}
                </button>
                <button mat-stroked-button color="default">Contact</button>
                <button mat-stroked-button color="default">Block</button>
              </div>
              <div *ngIf="isMyProfile" class="profileButtonRow d-flex">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="viewFollowers()"
                >
                  Followers
                </button>
                <button
                  mat-flat-button
                  color="primary"
                  (click)="viewFollowing()"
                >
                  Following
                </button>
                <button
                  mat-stroked-button
                  color="default"
                  routerLink="/settings/profile"
                >
                  Edit Profile
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-4 pt-4 text-left">
      <mat-card class="mat-elevation-z0 border h-100">
        <mat-card-header>
          <mat-card-title>Biography</mat-card-title>
        </mat-card-header>
        <mat-card-content sytle="text-align: left;">{{
          user.biography
        }}</mat-card-content>
      </mat-card>
    </div>
  </div>
  <!-- <div class="row" *ngIf="user && !isLoading">
    <div class="col-lg-6 pt-3 p-5 text-left order-lg-last">
      <h3 class="mat-h2">Biography</h3>
      <p class="mat-body">...</p>
      <h3 class="mat-h2">Badges</h3>
    </div>
     <div class="col-lg-6 pt-3 order-lg-first">
      <app-post-collection
        [title]="'Posts from ' + user.displayName"
        [loading]="postsFromUserLoading"
        [posts]="postsFromUser"
      ></app-post-collection>
    </div> 
  </div> -->

  } @else {
  <div class="row">
    <div class="p-5 col-md-12 d-flex justify-content-center">
      <p>This user does not exist!</p>
    </div>
  </div>
  } }
</div>
